export default __webpack_public_path__ + "static/media/pink4.11bd387b.mp4";